var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b(),style:({ backgroundColor: _vm.color })},[_vm._v(_vm._s(_vm.$t(`quoteStatus.${_vm.status}`)))])
}
var staticRenderFns = []

export { render, staticRenderFns }